import { isValidPhoneNumber } from 'react-phone-number-input'
import yup from './yup'

export const attendeeFormSchema = yup.object().shape({
  firstName: yup.string().label('First Name').trimmedRequired('First Name is required'),
  lastName: yup.string().label('Last Name').trimmedRequired('Last Name is required'),
  position: yup.string().label('Position').trimmedRequired('Position is required'),
  email: yup.string().label('Email').trimmedRequired('Email is required'),
  phoneNumber: yup
    .string()
    .label('Phone Number')
    .test('is-valid-phone-number', 'Please enter a valid phone number', (value) =>
      value ? isValidPhoneNumber(value) : true
    ),
  company: yup.string().label('Institute'),
  role: yup.string().label('Role').trimmedRequired('Role is required')
})
